var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13832",
    transform: "translate(-1264.771 -641.771)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3200",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1264.771 641.771)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12784",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1008",
    d: "M1282.149 652.648v13.658"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1009",
    d: "M1275.32 659.477h13.658"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRounded);
export default __webpack_public_path__ + "static/media/plus-rounded.63cb0f9cc7c6db0a78f4eb5ca565104a.svg";
export { ForwardRef as ReactComponent };